import { render, staticRenderFns } from "./OrderGroupQuery.vue?vue&type=template&id=7838566e&scoped=true"
import script from "./OrderGroupQuery.vue?vue&type=script&lang=js"
export * from "./OrderGroupQuery.vue?vue&type=script&lang=js"
import style0 from "./OrderGroupQuery.vue?vue&type=style&index=0&id=7838566e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7838566e",
  null
  
)

export default component.exports